export default "__VITE_ASSET__019b51b5__"